import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { showSuccess, showError } from '../../../components/ModernSnackbar';
import { verifyLink } from '../../../services/api/fytnServices';
import { Box, CircularProgress, Typography, Paper, Button } from '@mui/material';

const VerifyToken = ({ setUser }) => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const verifyToken = async () => {
      try {
        const res = await verifyLink(token);
        if (res.data?.data?.user) {
          showSuccess("User is Valid");
          setUser(res.data.data.user);
          sessionStorage.setItem('fytn_token', token);
          navigate('/test-new');
        } else {
          setErrorMessage('Invalid or expired link.');
          showError('User Link Invalid.');
          setLoading(false);
        }
      } catch (err) {
        setErrorMessage('Failed to verify token.');
        showError('Failed to verify token.');
        setLoading(false);
      }
    };

    verifyToken();
  }, [token, setUser, navigate]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100vh"
      bgcolor="#f9f9f9"
    >
      <Paper elevation={3} sx={{ p: 6, borderRadius: 2, textAlign: 'center', minWidth: 300 }}>
        {loading ? (
          <>
            <CircularProgress sx={{ color: '#6b46c1', mb: 2 }} />
            <Typography variant="h6" fontWeight="medium">
              Verifying your access...
            </Typography>
            <Typography variant="body2" mt={1} color="text.secondary">
              Please wait while we verify your link.
            </Typography>
          </>
        ) : (
          <>
            <Typography variant="h6" fontWeight="medium" color="error" mb={2}>
             Invalid User.
            </Typography>
       
          </>
        )}
      </Paper>
    </Box>
  );
};

export default VerifyToken;
